"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetHealth200ResponseInfoValueToJSON = exports.GetHealth200ResponseInfoValueFromJSONTyped = exports.GetHealth200ResponseInfoValueFromJSON = exports.instanceOfGetHealth200ResponseInfoValue = void 0;
/**
 * Check if a given object implements the GetHealth200ResponseInfoValue interface.
 */
function instanceOfGetHealth200ResponseInfoValue(value) {
    var isInstance = true;
    isInstance = isInstance && "status" in value;
    return isInstance;
}
exports.instanceOfGetHealth200ResponseInfoValue = instanceOfGetHealth200ResponseInfoValue;
function GetHealth200ResponseInfoValueFromJSON(json) {
    return GetHealth200ResponseInfoValueFromJSONTyped(json, false);
}
exports.GetHealth200ResponseInfoValueFromJSON = GetHealth200ResponseInfoValueFromJSON;
function GetHealth200ResponseInfoValueFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return __assign(__assign({}, json), { 'status': json['status'] });
}
exports.GetHealth200ResponseInfoValueFromJSONTyped = GetHealth200ResponseInfoValueFromJSONTyped;
function GetHealth200ResponseInfoValueToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return __assign(__assign({}, value), { 'status': value.status });
}
exports.GetHealth200ResponseInfoValueToJSON = GetHealth200ResponseInfoValueToJSON;
